// components/ConfirmStrategyModal.jsx
import React from "react";
import { useTheme } from "../../../context/ThemeContext";
import Cross from "../../../images/Builder/cross.svg";
import CrossDark from "../../../images/Builder/cross_dark.svg";

export default function ConfirmStrategyModal({ isOpen, onConfirm, onCancel }) {
    const { theme } = useTheme();
    return (
      <dialog
        id="confirm_strategy_modal"
        className={`modal ${isOpen ? "modal-open" : ""}`}>
        <div className="modal-box p-6 rounded-xl text-center bg-modalBg max-w-64">
          <div className="flex flex-col items-center">
            <div className="text-4xl">🤔</div>
            <h3 className="font-medium text-[14px] mt-3 text-p300">
              Confirmation
            </h3>
            <p className="text-[12px] font-medium text-n500 mt-1 max-w-52">
              Are you sure? Do you want to execute this strategy?
            </p>
          </div>

          <div className="flex justify-center gap-3 mt-6">
            <button
              className="border border-n200 px-4 py-2 rounded-lg "
              onClick={onCancel}>
              <img src={theme === "dark" ? CrossDark : Cross} alt="Execute icon" className="w-2 h-2" />
            </button>
            <button
              className="bg-swipe-button text-p400 px-4 py-2 rounded-lg w-36 text-sm font-semibold text-[12px] flex items-center justify-center gap-2"
              onClick={onConfirm}>
              <p>Yes, Proceed</p>
            </button>
          </div>
        </div>
      </dialog>
    );
}
